import { theme } from "../../constants/StyledComponents";
import { FontWeightEnum } from "../../types/AppTypes";
import { getInitials } from "../../utils/collaborators.utils";
import { capitalize } from "../../utils/string.utils";
import { Avatar, AvatarDimensionsEnum } from "../core/Avatar/Avatar";
import { BodyTyp, CaptionsTyp } from "../Typography/Typography";
import { StyledUserContainer } from "./UserChip.styled";

type UserChipProps = {
  id: number;
  name: string;
  surname: string;
  role: string;
  onClick?: () => void;
  isLoggedUser?: boolean;
};

const UserChip = ({
  id,
  name,
  surname,
  role,
  onClick,
  isLoggedUser,
}: UserChipProps) => {
  return (
    <StyledUserContainer key={id} onClick={onClick}>
      <Avatar
        variant={AvatarDimensionsEnum.SMALL}
        collaboratorId={id}
        initials={getInitials(name, surname)}
      />
      <div>
        <BodyTyp
          fontWeight={
            isLoggedUser ? FontWeightEnum.MEDIUM : FontWeightEnum.REGULAR
          }
        >
          {capitalize(surname)} {capitalize(name)}
        </BodyTyp>
        <CaptionsTyp
          color={isLoggedUser ? theme.colors.purple : theme.colors.grey_2}
          fontWeight={
            isLoggedUser ? FontWeightEnum.SEMIBOLD : FontWeightEnum.REGULAR
          }
        >
          {role}
        </CaptionsTyp>
      </div>
    </StyledUserContainer>
  );
};

export default UserChip;
